<script setup>
import { watch } from 'vue'
import { useModalStore } from '@/store/modal'
import CreateUpdateCategoryModal from '@/components/modals/CreateUpdateCategoryModal.vue'
import InsufficientTokensModal from '@/components/modals/InsufficientTokensModal.vue'
import ResponseStatusConfirm from '@/components/modals/ResponseStatusConfirm.vue'
import CreateUpdateProductModal from '@/components/modals/CreateUpdateProductModal.vue'
import ShowBuildingModal from '@/components/modals/ShowBuildingModal.vue'

const modal = useModalStore()
const modals = {
  CreateUpdateCategoryModal,
  InsufficientTokensModal,
  ResponseStatusConfirm,
  CreateUpdateProductModal,
  ShowBuildingModal
}
watch(() => modal.activeModal, (newVal) => {
  if (newVal) {
    document.body.classList.add('overflow-hidden')
  } else {
    document.body.classList.remove('overflow-hidden')
  }
})
</script>

<template>
    <teleport to="body">
      <transition name="fade">
        <div
          v-if="modal.activeModal"
          class="fixed inset-0 z-50 flex items-center justify-center"
        >
          <!-- overlay -->
          <div
            class="absolute inset-0 bg-black/50 backdrop-blur-sm"
            @click="modal.modalOptions.backdropClosable ? modal.rejectModal('backdrop') : null"
          />
  
          <!-- actual modal -->
          <component
            :is="modals[modal.activeModal]"
            class="relative z-50"
          />
        </div>
      </transition>
    </teleport>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>